// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

interface XProductPartNumbersStyles {
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    largeLabel: TypographyPresentationProps;
    largeValue: TypographyPresentationProps;
    labelWithoutDot?: TypographyPresentationProps;
}

const mediumTextStyles: TypographyPresentationProps = {
    ...fontConfig.xSmallSingleLine,
    weight: fontConfig.weight.regular,
    color: "common.ui5",
};

const largeTextStyles: TypographyPresentationProps = {
    ...fontConfig.smallSingleLine,
    weight: fontConfig.weight.regular,
    color: "common.ui5",
};

const xProductPartNumbersStyles: XProductPartNumbersStyles = {
    label: {
        ...mediumTextStyles,
        css: css`
            letter-spacing: 0;
            margin-right: 4px;
            margin-bottom: 0;
            text-wrap: nowrap;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        ...mediumTextStyles,
        ellipsis: true,
        css: css`
            letter-spacing: 0;
            ${wrapInContainerStyles}
        `,
    },
    largeLabel: {
        ...largeTextStyles,
        css: css`
            letter-spacing: 0;
            margin-right: 4px;
            margin-bottom: 0;
            text-wrap: nowrap;
            flex-shrink: 0;
            display: inline-block;
            line-height: ${fontConfig.smallSingleLine.lineHeight};

            &:after {
                content: ":";
            }
        `,
    },
    largeValue: {
        ...largeTextStyles,
        ellipsis: true,
        css: css`
            letter-spacing: 0;
            line-height: ${fontConfig.smallSingleLine.lineHeight};
            ${wrapInContainerStyles}
        `,
    },
};

xProductPartNumbersStyles.labelWithoutDot = mergeWithCss(xProductPartNumbersStyles.largeLabel, {
    css: css`
        &:after {
            display: none;
        }
    `,
});


export default xProductPartNumbersStyles;
